import React from 'react';
import { Typography, Flex, theme } from 'antd';

type SurveyHeadingProps = {
  currentQuestionIndex: number;
  totalQuestions: number;
  question: string;
  questionHint?: string;
};

function SurveyHeading({ currentQuestionIndex, totalQuestions, question, questionHint }: SurveyHeadingProps) {
  const { token } = theme.useToken();

  return (
    <Flex align="center" justify="center" vertical>
      <Typography.Paragraph type="secondary" style={{ marginBottom: token.marginXS }}>
        Question {currentQuestionIndex + 1} of {totalQuestions}
      </Typography.Paragraph>
      <Flex gap="small">
        <Typography.Title style={{ marginTop: 0, marginBottom: token.marginMD }} level={3}>
          {question}
        </Typography.Title>
        <Typography.Title type="secondary" style={{ marginTop: 0, marginBottom: token.marginMD }} level={3}>
          {questionHint}
        </Typography.Title>
      </Flex>
    </Flex>
  );
}

export default SurveyHeading;
